import React, { useContext, useEffect, useState } from 'react'
import activeIcon from '../../images/svg/activeIcon.svg'
import notActiveIcon from '../../images/svg/notActiveIcon.svg'
import blockIcon from '../../images/svg/blockIcon.svg'
import { UserContext } from '../../context/user'
import optionIcon from '../../images/svg/optionIcon.svg'
import api from '../../services/api'
import { ServiceContext } from '../../context/service'
import { CategoryContext } from '../../context/categorys'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const TableListModels = ({ update }) => {

    const { getService, servicesModal } = useContext(ServiceContext)
    const { getUser } = useContext(UserContext)
    const { getCategory } = useContext(CategoryContext)
    const [categorys, setCategorys] = useState([])
    const [animation, setAnimation] = useState(null)

    const getAll = async () => {
        const response = await api.get("panel/get/all/categorys/menu")
        if (response.status == 200) {
            setCategorys(response.data)
            setTimeout(() => {

                setAnimation(false)

            }, [2000])
        }

    }

    useEffect(() => {

        if (servicesModal) {
            setCategorys(servicesModal)
        }

    }, [servicesModal])

    useEffect(() => {

        getAll()

    }, [])


    useEffect(() => {

        getAll()
    }, [update])

    return (

        <>
            {/* 
            <table class="gfg">
                <tr>

                    <td style={{ color: "#6A6A6A", width: "400px" }}>Usuário</td>
                    <td style={{ color: "#6A6A6A", width: "300px" }}>Categoria</td>
                    <td style={{ color: "#6A6A6A", width: "370px" }}>E-mail</td>
                    <td style={{ color: "#6A6A6A", width: "370px" }}>Celular</td>
                    <td style={{ color: "#6A6A6A", width: "170px" }}>Status</td>
                    <td style={{ color: "#6A6A6A", width: "240px" }}>Opções</td>

                </tr>




            </table>
            <table class="gfg">

                {categorys.length > 0 
                
                ?
                categorys.map(item => {

                    return (
                        animation == null

                            ?

                            <tr>
                                <td style={{ width: "100%", border: "none", background: "none" }}><Skeleton style={{ width: "100%", height: "50px" }} /></td>
                                <td style={{ width: "100%", border: "none", background: "none" }}><Skeleton style={{ width: "100%", height: "50px" }} /></td>
                                <td style={{ width: "100%", border: "none", background: "none" }}><Skeleton style={{ width: "100%", height: "50px" }} /></td>

                            </tr>

                            :
                            <tr>
                                <td style={{ width: "270px" }}>
                                </td>

                                <td style={{ width: "270px" }} data-toggle="modal" data-target="#editCategoryModal" onClick={() => getCategory(item.id, item.name)}><img src={item.user_image} className='image_tablelist' />{item.user_name != undefined ? item.user_name : <></>}</td>
                                <td style={{ width: "270px" }} data-toggle="modal" data-target="#editCategoryModal" onClick={() => getCategory(item.id, item.name)}>{item.name}</td>
                                <td style={{ width: "270px" }} data-toggle="modal" data-target="#editCategoryModal" onClick={() => getCategory(item.id, item.name)}>{item.mail}</td>
                                <td style={{ width: "270px" }} data-toggle="modal" data-target="#editCategoryModal" onClick={() => getCategory(item.id, item.name)}>{item.phone}</td>
                                <td style={{ width: "270px" }} data-toggle="modal" data-target="#editCategoryModal" onClick={() => getCategory(item.id, item.name)}>{item.state == undefined ? <img src={activeIcon} /> : item.state == 2 ? <img src={notActiveIcon} /> : item.state == 3 ? <img src={blockIcon} /> : <></>}</td>
                                <td style={{ width: "270px" }} data-toggle="modal" data-target="#options" onClick={() => getCategory(item.id, item.name)}><img src={optionIcon} /></td>

                            </tr>
                    )


                })
                :
                <></>
                }

      


            </table> */}



            <div className='container_startpn_table'>
                <table>
                    <thead>
                        <tr>
                            <td>Usuário</td>
                            <td>Produto</td>
                            <td>E-mail</td>
                            <td>Celular</td>
                            <td>Status</td>
                            <td>Opções</td>

                        </tr>
                    </thead>
                    <tbody>


                        {categorys.map(item => {

                            return(
                                <tr>
                                <td   data-toggle="modal" data-target="#editService"  onClick={() => getCategory(item.id, item.name)} >
                                    <p className='textPrimaryuserTable'>{item.user_name}</p>
                                </td>
                                <td   data-toggle="modal"  data-target="#editCategoryModal"  onClick={() => getCategory(item.id, item.name)}><p className='textPrimaryuserTable'>{item.name}</p></td>
                                <td   data-toggle="modal"  data-target="#editCategoryModal"  onClick={() => getCategory(item.id, item.name)}><p className='textPrimaryuserTable'>{item.mail}</p></td>
                                <td   data-toggle="modal"  data-target="#editCategoryModal"  onClick={() => getCategory(item.id, item.name)}><p className='textPrimaryuserTable'>{item.phone}</p></td>
                                <td   data-toggle="modal"  data-target="#editCategoryModal"  onClick={() => getCategory(item.id, item.name)}>
                                    <svg width="106" height="28" viewBox="0 0 106 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="106" height="28" rx="14" fill="#E0FFF0" />
                                        <path d="M43.534 17.154H39.751L39.101 19H37.554L40.791 9.952H42.507L45.744 19H44.184L43.534 17.154ZM43.118 15.945L41.649 11.746L40.167 15.945H43.118ZM48.5471 13.046V17.011C48.5471 17.2797 48.6078 17.4747 48.7291 17.596C48.8591 17.7087 49.0758 17.765 49.3791 17.765H50.2891V19H49.1191C48.4518 19 47.9404 18.844 47.5851 18.532C47.2298 18.22 47.0521 17.713 47.0521 17.011V13.046H46.2071V11.837H47.0521V10.056H48.5471V11.837H50.2891V13.046H48.5471ZM52.0757 10.888C51.807 10.888 51.5817 10.797 51.3997 10.615C51.2177 10.433 51.1267 10.2077 51.1267 9.939C51.1267 9.67033 51.2177 9.445 51.3997 9.263C51.5817 9.081 51.807 8.99 52.0757 8.99C52.3357 8.99 52.5567 9.081 52.7387 9.263C52.9207 9.445 53.0117 9.67033 53.0117 9.939C53.0117 10.2077 52.9207 10.433 52.7387 10.615C52.5567 10.797 52.3357 10.888 52.0757 10.888ZM52.8037 11.837V19H51.3217V11.837H52.8037ZM57.1851 17.674L59.2131 11.837H60.7861L58.0561 19H56.2881L53.5711 11.837H55.1571L57.1851 17.674ZM64.68 19.117C64.004 19.117 63.393 18.9653 62.847 18.662C62.301 18.35 61.872 17.9167 61.56 17.362C61.248 16.7987 61.092 16.1487 61.092 15.412C61.092 14.684 61.2523 14.0383 61.573 13.475C61.8937 12.9117 62.3313 12.4783 62.886 12.175C63.4407 11.8717 64.0603 11.72 64.745 11.72C65.4297 11.72 66.0493 11.8717 66.604 12.175C67.1587 12.4783 67.5963 12.9117 67.917 13.475C68.2377 14.0383 68.398 14.684 68.398 15.412C68.398 16.14 68.2333 16.7857 67.904 17.349C67.5747 17.9123 67.124 18.35 66.552 18.662C65.9887 18.9653 65.3647 19.117 64.68 19.117ZM64.68 17.83C65.0613 17.83 65.4167 17.739 65.746 17.557C66.084 17.375 66.357 17.102 66.565 16.738C66.773 16.374 66.877 15.932 66.877 15.412C66.877 14.892 66.7773 14.4543 66.578 14.099C66.3787 13.735 66.1143 13.462 65.785 13.28C65.4557 13.098 65.1003 13.007 64.719 13.007C64.3377 13.007 63.9823 13.098 63.653 13.28C63.3323 13.462 63.0767 13.735 62.886 14.099C62.6953 14.4543 62.6 14.892 62.6 15.412C62.6 16.1833 62.795 16.7813 63.185 17.206C63.5837 17.622 64.082 17.83 64.68 17.83Z" fill="#00B386" />
                                    </svg>
                                </td>
                                <td data-toggle="modal" data-target="#options" onClick={() => getCategory(item.id, item.name)} >

                                    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse cx="1.93767" cy="1.93767" rx="1.93767" ry="1.93767" fill="black" />
                                        <ellipse cx="1.93767" cy="8.81316" rx="1.93767" ry="1.93767" fill="black" />
                                        <ellipse cx="1.93767" cy="15.6882" rx="1.93767" ry="1.93767" fill="black" />
                                    </svg>

                                </td>

                            </tr>
                            )
                        })}


                    </tbody>
                </table>
            </div>



        </>

    )
}

export default TableListModels